import { useEffect, useState } from "react";

const DURATION_MS = (17 * 60 + 34) * 1000;
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = now - START;
  const remainingMs = DURATION_MS - (elapsed % DURATION_MS);
  const totalSeconds = Math.floor(remainingMs / 1000);

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
